/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const COL_SPANS = {
  issues: 9,
  status: 2,
  assignee: 1,
  updated: 2,
  actions: 1,
  total: 15,
};

export const TableContainer = styled.div({
  marginBottom: token('space.300', '24px'),
});

export const TableHeaders = styled.tr({
  "th[data-issue-column='issue-summary-column']": {
    paddingRight: 0,
  },
  "th[data-issue-column='issue-assignee-column']": {
    paddingLeft: 0,
  },
});

export const TableRow = styled.tr<{ isFocused?: boolean }>(props => ({
  height: token('space.600', '48px'),
  backgroundColor: props.isFocused
    ? token('color.background.neutral', colors.N20)
    : 'initial',

  '&:hover, &:focus': {
    backgroundColor: token(
      'color.background.neutral.subtle.hovered',
      colors.N20
    ),
    boxShadow: `${token('elevation.shadow.raised', colors.N20)} 0 0 0 ${token(
      'space.negative.050',
      '-4px'
    )}, ${token('elevation.shadow.raised', colors.N20)} 0 0 0 ${token(
      'space.050',
      '4px'
    )}`,
    borderRadius: token('border.radius', '3px'),
  },

  "td[data-issue-column='issue-summary-column']": {
    paddingRight: 0,
  },

  "td[data-issue-column='issue-assignee-column']": {
    paddingLeft: 0,
  },
}));

export const AssigneeWrapper = styled.div({
  paddingLeft: token('space.200', '16px'),
  paddingTop: '3px',
});

export const ActionsWrapper = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingRight: token('space.100', '8px'),
});

export const PaginationWrapper = styled.div({
  padding: `${token('space.100', '8px')} 0 ${token('space.100', '8px')}`,
});

export const EmptyStateWrapper = styled.div({
  height: `${gridSize() * 44}px`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'normal',
});

export const SummaryContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '100%',
});

export const SummaryInnerContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  /* Without this the focus ring (when tabbing with the keyboard) would not be visible. */
  height: '100%',
  padding: `0 ${token('space.050', '4px')}`,
});
